import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./ContenidoVisual.css";

// items will be loaded via translation

interface VisualItem {
  imagen: string;
  icono?: string;
  titulo: string;
  texto: string;
}

interface VisualItemComponentProps {
  item: VisualItem;
  idx: number;
  t: any;
}

const VisualItemComponent: React.FC<VisualItemComponentProps> = ({ item, idx, t }) => {
  const [isVisible, setIsVisible] = useState(false);
  const itemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false); // Reset animation when out of viewport
        }
      },
      {
        threshold: 0.3, // 30% del elemento visible
        rootMargin: '0px 0px -50px 0px' // Trigger un poco antes
      }
    );

    if (itemRef.current) {
      observer.observe(itemRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="visual-texto-item" ref={itemRef}>
      <div className="visual-img">
        <img
          className="visual-img-fondo"
          src={item.imagen}
          alt={t("alt.image", { id: idx + 1 })}
        />
        <div className="visual-img-overlay">
          {item.icono && (
            <img
              src={`/icons/${item.icono}`}
              alt={t("alt.icon")}
              className="icono-titulo"
            />
          )}
          <h3>{item.titulo}</h3>
        </div>
      </div>
      <div className={`visual-texto ${isVisible ? 'animate-in' : ''}`}>
        <p>{item.texto}</p>
      </div>
    </div>
  );
};

export default function ContenidoVisual() {
  const { t } = useTranslation();

  const items = t("contenido_visual.items", { returnObjects: true }) as VisualItem[];

  return (
    <section className="visual-texto-section">
      {Array.isArray(items) && items.map((item: VisualItem, idx: number) => (
        <VisualItemComponent key={idx} item={item} idx={idx} t={t} />
      ))}
    </section>
  );
}
